if (!customElements.get('cart-drawer-discount')) {
  customElements.define(
    'cart-drawer-discount',
    class CartDrawerDiscount extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('[data-cart-discount-input]');
        this.applyButton = this.querySelector('[data-cart-discount-apply]');
        this.message = this.querySelector('[data-cart-discount-message]');

        if (!this.form || this.form.dataset.bound === 'true') return;
        this.form.dataset.bound = 'true';
        if (this.applyButton) {
          this.applyButton.classList.remove('button', 'button--secondary', 'button--tertiary');
        }
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      setMessage(text, type) {
        if (!this.message) return;
        this.message.textContent = text || '';
        this.message.classList.toggle('hidden', !text);
        this.message.classList.toggle('cart-drawer-discount__message--error', type === 'error');
        this.message.classList.toggle('cart-drawer-discount__message--success', type === 'success');
      }

      setLoading(isLoading) {
        if (this.applyButton) {
          this.applyButton.disabled = isLoading;
        }
        if (this.input) this.input.disabled = isLoading;
      }

      async refreshCartDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer || typeof cartDrawer.fetchCartSections !== 'function') return;

        const sections = await cartDrawer.fetchCartSections();
        cartDrawer.applySectionsFromState({ sections });
      }

      async onSubmit(event) {
        event.preventDefault();
        const code = this.input?.value.trim();
        if (!code) {
          this.setMessage('Enter a discount code.', 'error');
          return;
        }

        this.setMessage('');
        this.setLoading(true);

        try {
          await fetch(`/discount/${encodeURIComponent(code)}`, {
            method: 'GET',
            credentials: 'include',
          });

          await this.refreshCartDrawer();

          const cart = await fetch(`${window.routes.cart_url}.js`, { credentials: 'include' }).then((response) =>
            response.json()
          );

          const applied =
            cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;

          if (applied) {
            this.setMessage('Discount applied.', 'success');
            if (this.input) this.input.value = '';
          } else {
            this.setMessage('Discount code applied. Savings show at checkout if valid.', 'success');
            if (this.input) this.input.value = '';
          }
        } catch (error) {
          console.error(error);
          this.setMessage('Could not apply that code. Please try again.', 'error');
        } finally {
          this.setLoading(false);
          this.applyButton?.blur();
        }
      }
    }
  );
}
